module.exports = __webpack_public_path__ + "static/media/client13.d6a1a116.webp";